import React, {
  createContext,
  useReducer,
  useContext,
  ReactNode,
} from 'react';
import {
  CloneMentorshipProgramState,
  CloneMentorshipProgramAction,
} from './types';
import {
  cloneMentorshipProgramReducer,
  initialState as defaultInitialState,
} from './reducer';

type CloneMentorshipProgramContextProps = {
  state: CloneMentorshipProgramState;
  dispatch: React.Dispatch<CloneMentorshipProgramAction>;
};

const CloneMentorshipProgramContext = createContext<CloneMentorshipProgramContextProps | undefined>(undefined);

type CloneMentorshipProgramProviderProps = {
  children: ReactNode;
  defaultState?: Partial<CloneMentorshipProgramState>;
};

export const CloneMentorshipProgramProvider = ({ children, defaultState }: CloneMentorshipProgramProviderProps) => {
  const [state, dispatch] = useReducer(cloneMentorshipProgramReducer, { ...defaultInitialState, ...defaultState });

  return (
    <CloneMentorshipProgramContext.Provider value={{ state, dispatch }}>
      {children}
    </CloneMentorshipProgramContext.Provider>
  );
};

export const useCloneMentorshipProgram = () => {
  const context = useContext(CloneMentorshipProgramContext);
  if (context === undefined) {
    throw new Error('useCloneMentorshipProgram must be used within a CloneMentorshipProgramProvider');
  }
  return context;
};
